/** Shared handoff geometry — opener logo + bridge tagline + hero headline */
export const INTRO_LOGO_MAX_WIDTH_MOBILE = 260;
export const INTRO_LOGO_MAX_WIDTH_DESKTOP = 510;
export const INTRO_LOGO_MAX_WIDTH = INTRO_LOGO_MAX_WIDTH_DESKTOP;
export const introLogoMaxWidthSx = {
  xs: INTRO_LOGO_MAX_WIDTH_MOBILE,
  md: INTRO_LOGO_MAX_WIDTH_DESKTOP,
} as const;
export const INTRO_LOGO_TAGLINE_GAP_PX = 22;
export const KANZLEI_TAGLINE_LINE_HEIGHT_PX = 20;
export const INTRO_HANDOFF_Z_TAGLINE = 10001;
export const INTRO_HANDOFF_Z_LOGO = 10002;
export { INTRO_HANDOFF_S as INTRO_HEADLINE_FADE_S } from './introTiming';

export const introLogoTop = (logoHeightVar = 'var(--intro-logo-height, 72px)') =>
  `calc(50svh - (${logoHeightVar} + var(--intro-logo-tagline-gap, ${INTRO_LOGO_TAGLINE_GAP_PX}px) + ${KANZLEI_TAGLINE_LINE_HEIGHT_PX}px) / 2 + var(--intro-mobile-vertical-nudge, 0px))`;

export const introOpenerLogoTop = (logoHeightVar = 'var(--intro-logo-height, 72px)') =>
  `calc(${introLogoTop(logoHeightVar)} + var(--intro-opener-logo-offset, 5px))`;

export const kanzleiTaglineTop = (logoHeightVar = 'var(--intro-logo-height, 72px)') =>
  `calc(${introLogoTop(logoHeightVar)} + ${logoHeightVar} + var(--intro-logo-tagline-gap, ${INTRO_LOGO_TAGLINE_GAP_PX}px))`;

export const heroHeadlineTop = (logoHeightVar = 'var(--intro-logo-height, 72px)') =>
  `calc(${introLogoTop(logoHeightVar)} + var(--intro-hero-headline-nudge, 0px))`;
